<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-list>
          <v-list-item>
            <v-list-item-title>Refresh toutes les recettes</v-list-item-title>
            <v-list-item-action>
              <v-btn @click="saveAllRecipes">
                <v-icon left small>fa-bolt</v-icon>
                Exécuter
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Recalcule corrections</v-list-item-title>
            <v-list-item-action>
              <v-btn @click="resetCorrectionValues">
                <v-icon left small>fa-bolt</v-icon>
                Exécuter
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "DebugIndex",
  computed: {
    ...mapGetters([
      "getRecipes",
      "getProducts",
      "getAvailablesStores",
      "getStoreId"
    ])
  },
  data() {
    return {
      store: null
    };
  },
  methods: {
    async convertProducts() {
      try {
        this.$store.dispatch("slo");
        await api.convertProducts();
      } finally {
        this.$store.dispatch("elo");
      }
    },
    async convertRecipes() {
      try {
        this.$store.dispatch("slo");
        await api.convertRecipes();
      } finally {
        this.$store.dispatch("elo");
      }
    },
    async convertInventoryRecords() {
      try {
        this.$store.dispatch("slo");
        await api.convertInventoryRecords();
      } finally {
        this.$store.dispatch("elo");
      }
    },
    async resetConversion() {
      try {
        this.$store.dispatch("slo");
        await api.resetConversion();
      } finally {
        this.$store.dispatch("elo");
      }
    },
    async resetCorrectionValues() {
      try {
        this.$store.dispatch("slo");
        await api.resetCorrectionValues();
      } finally {
        this.$store.dispatch("elo");
      }
    },
    async saveAllRecipes() {
      try {
        this.$store.dispatch("slo");
        await this.$store.dispatch("loadProducts");
        await this.$store.dispatch("loadRecipes");
        const tasks = [];
        this.getRecipes.forEach(x => {
          const d = {
            ...x,
            allergens: this.getIngredientsAllergens(x)
          };
          tasks.push(api.patchRecipe(x.id, d));
        });
        await Promise.all(tasks);
      } finally {
        this.$store.dispatch("elo");
      }
    },
    getIngredientsAllergens(recipe) {
      return [
        ...new Set(
          recipe.ingredients
            .filter(x => x.is_deleted === false)
            .map(x => {
              if (
                this.getProducts.find(p => p.id === x.pk_recette_produit) &&
                this.getProducts.find(p => p.id === x.pk_recette_produit).data
              ) {
                const product = this.getProducts.find(
                  p => p.id === x.pk_recette_produit
                );
                if (product.data.allergens.length > 0) {
                  return product.data.allergens;
                } else {
                  return [];
                }
              }
            })
            .flat()
        )
      ].filter(x => x !== undefined);
    },
    async overwriteData() {
      const allow = await this.$dialog.confirm({
        text:
          "Voulez-vous remplacer toutes les données des produits et recette par celle de la succursale sélectionnée?",
        title: ""
      });
      if (allow) {
        try {
          this.$store.dispatch("slo");
          await Promise.all([
            api.overwriteProductStoreData(
              { store: this.store },
              api.overwriteRecipeStoreData({ store: this.store })
            )
          ]);
        } finally {
          this.$store.dispatch("elo");
        }
      }
    }
  }
};
</script>

<style></style>
